import { call } from "redux-saga/effects"
import { updateMultisiteSelectorCall } from "../../apis/wpApi/apiCalls"
import authUser from "../../apis/wpApi/authUser"
import { checkResponse } from "../helpers"

export function* updateMultisiteSelector(data) {
    if(!data) {
        throw new Error('No multisite selctor data') 
    }

    const apiKey = yield call(authUser.getToken)
    const response = yield call(updateMultisiteSelectorCall, apiKey, {selector: data})

    yield call(checkResponse, response, ['edited', 'items', 'order'])
    return yield response
}